
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runTestCasesWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runTestCasesWithTimeout" in module)) throw new SyntaxError(`export 'runTestCasesWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput, testReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runTestCasesWithTimeout,codeEditor,ok,err,hint,consoleOutput,testReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runTestCasesWithTimeout","codeEditor","ok","err","hint","consoleOutput","testReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-4`),
    expanded: [],
    variables: []
  },
  {
    id: 4,
    body: (view,codeEditor) => {
const demo_motiv = view(codeEditor("functions:motivation", {
  value: 'const animal = "Katze"\n\nif (animal == "Katze") {\n  console.log("Achtung!")\n  console.log("Raubtier entdeckt")\n} else if (animal == "Hund") {\n  console.log("Achtung!")\n  console.log("Raubtier entdeckt")\n} else if (animal == "Wolf") {\n  console.log("Achtung!")\n  console.log("Raubtier entdeckt")\n} else {\n  console.log("Kein Raubtier")\n}'
}));
return {demo_motiv};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_motiv"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: async (display,consoleOutput,runWithConsole,demo_motiv) => {
display(consoleOutput(await runWithConsole(demo_motiv)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_motiv"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-7`),
    expanded: [],
    variables: []
  },
  {
    id: 7,
    body: (view,codeEditor) => {
const demo_motiv_fixed = view(codeEditor("functions:motivation_fixed", {
  value: 'function warn() {\n  console.log("Achtung!")\n  console.log("Raubtier entdeckt")\n}\n\nconst animal = "Katze"\n\nif (animal == "Katze") {\n  warn()\n} else if (animal == "Hund") {\n  warn()\n} else if (animal == "Wolf") {\n  warn()\n} else {\n  console.log("Kein Raubtier")\n}'
}));
return {demo_motiv_fixed};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_motiv_fixed"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: async (display,consoleOutput,runWithConsole,demo_motiv_fixed) => {
display(consoleOutput(await runWithConsole(demo_motiv_fixed)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_motiv_fixed"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const demo_syn = view(codeEditor("functions:syntax", {
  value: 'function sayHello() {\n  console.log("Hallo")\n  console.log("Ich bin in einer Funktion.")\n}\n\nsayHello()\nsayHello()\nsayHello()'
}));
return {demo_syn};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_syn"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: async (display,consoleOutput,runWithConsole,demo_syn) => {
display(consoleOutput(await runWithConsole(demo_syn)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_syn"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_params = view(codeEditor("functions:params", {
  value: 'function sayIfAdult(age) {\n  if (age >= 18) {\n    console.log("Mit " + age + " bist du volljährig.")\n  } else {\n    console.log("Mit " + age + " bist du minderjährig.")\n  }\n}\n\nsayIfAdult(12)\nsayIfAdult(27)\nsayIfAdult(48)\nsayIfAdult(8)\nsayIfAdult(18)'
}));
return {demo_params};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_params"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_params) => {
display(consoleOutput(await runWithConsole(demo_params)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_params"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (view,codeEditor) => {
const demo_multi = view(codeEditor("functions:multi", {
  value: 'function saySum(x, y) {\n  console.log("Die Summe von " + x + " und " + y + " ist " + (x + y) + ".")\n}\n\nsaySum(2, 3)\nsaySum(100, 50)'
}));
return {demo_multi};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_multi"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: async (display,consoleOutput,runWithConsole,demo_multi) => {
display(consoleOutput(await runWithConsole(demo_multi)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_multi"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (view,codeEditor) => {
const demo_return = view(codeEditor("functions:return", {
  value: 'function isTeenager(age) {\n  return age >= 13 && age <= 19\n}\n\nconsole.log(isTeenager(15))\nconsole.log(isTeenager(8))\nconsole.log(isTeenager(20))\n\n// Du kannst den return-Wert direkt weiterverwenden:\nif (isTeenager(17)) {\n  console.log("17 ist ein Teenager-Alter.")\n}'
}));
return {demo_return};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_return"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: async (display,consoleOutput,runWithConsole,demo_return) => {
display(consoleOutput(await runWithConsole(demo_return)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_return"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (view,codeEditor) => {
const demo_abs = view(codeEditor("functions:absolute", {
  value: 'function absolute(number) {\n  if (number < 0) {\n    return -number\n  }\n  return number\n}\n\nconsole.log(absolute(5))\nconsole.log(absolute(-7))\nconsole.log(absolute(0))'
}));
return {demo_abs};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_abs"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: async (display,consoleOutput,runWithConsole,demo_abs) => {
display(consoleOutput(await runWithConsole(demo_abs)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_abs"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-30`),
    expanded: [],
    variables: []
  },
  {
    id: 30,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("functions:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-31`),
    expanded: [],
    variables: []
  },
  {
    id: 31,
    body: (runTestCasesWithTimeout,uebung_code) => {
const uebungResult = runTestCasesWithTimeout({
  code: uebung_code,
  fnName: "getMagicNumber",
  cases: [
    [[2024, 30], 46],
    [[2018, 18], 6],
    [[2035, 5], 22]
  ]
});
return {uebungResult};
},
    inputs: ["runTestCasesWithTimeout","uebung_code"],
    outputs: ["uebungResult"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-32`),
    expanded: [],
    variables: []
  },
  {
    id: 32,
    body: (display,testReport,uebungResult) => {
display(testReport(uebungResult, "getMagicNumber"));
},
    inputs: ["display","testReport","uebungResult"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
